"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const index_1 = require("../index");
function SyncNotification(notificationData) {
    var _a;
    const [loading, setLoading] = (0, react_1.useState)(false);
    const syncDict = i18n_1.Strings.settings.notifications.sync;
    const notification = notificationData === null || notificationData === void 0 ? void 0 : notificationData.notification;
    const description = (_a = notification.data) === null || _a === void 0 ? void 0 : _a.map((actions, i) => {
        return actions.map(([action, count, type], j) => {
            const isLastElement = notification.data.length === i + 1 && actions.length === j + 1;
            return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, i18n_1.Localized)(syncDict[action]), " ", (0, i18n_1.Localized)(syncDict[type], { count }), !isLastElement && '. '] }, `${i}-${j}`));
        });
    });
    const syncAction = () => {
        setLoading(true);
    };
    const buttons = [
        {
            action: () => { },
            icon: ui_1.Icons.Cross,
            isSyncNotify: true,
            type: index_1.ButtonType.Flat,
            identifier: notification === null || notification === void 0 ? void 0 : notification.identifier,
            title: (0, i18n_1.Localized)(i18n_1.Strings.settings.notifications.ignore),
        },
        {
            icon: ui_1.Icons.Sync,
            action: syncAction,
            isSyncNotify: true,
            isLoading: loading,
            setLoading: setLoading,
            type: index_1.ButtonType.Flat,
            identifier: notification === null || notification === void 0 ? void 0 : notification.identifier,
            title: loading
                ? (0, i18n_1.Localized)(i18n_1.Strings.settings.notifications.sync.synchronizing)
                : (0, i18n_1.Localized)(i18n_1.Strings.settings.notifications.sync.syncToView),
        },
    ];
    return ((0, jsx_runtime_1.jsx)(index_1.Notification, { notification: notification, 
        /* eslint-disable-next-line react/jsx-no-useless-fragment */
        description: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: description }), title: (0, i18n_1.Localized)(syncDict.contentUpdate), important: true, isGroup: true, buttons: loading ? [buttons[1]] : buttons, "data-e2e": 'SyncNotification_Notification' }));
}
exports.default = SyncNotification;
